var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8436_16811)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8436_16811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.784 24.0948L42.1949 24C39.5531 24.0098 37.0212 25.0644 35.147 26.9356C33.2728 28.8068 32.2067 31.3443 32.1795 33.9992L32.0664 68.8492C32.0737 71.5024 33.1211 74.046 34.9817 75.9284C36.8423 77.8107 39.3661 78.8803 42.0061 78.9054L56.6046 79C59.2463 78.9925 61.7785 77.9387 63.6518 76.0665C65.525 74.1943 66.5882 71.6555 66.6106 69.001L66.7331 34.1508C66.716 31.4988 65.6641 28.9597 63.8035 27.0791C61.943 25.1986 59.4225 24.127 56.784 24.0948Z",
    fill: "#9057F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7812 40.2123C26.5821 44.3964 25.6543 49.1487 26.1153 53.8681C26.5763 58.5875 28.4053 63.0621 31.371 66.7261C34.3368 70.3901 38.306 73.0789 42.7768 74.4522C47.2477 75.8259 52.0193 75.8223 56.4883 74.4425C60.9572 73.0627 64.9227 70.3681 67.8833 66.7001C70.8439 63.0319 72.667 58.5546 73.1211 53.8345C73.5757 49.1145 72.6414 44.3636 70.4366 40.1827C68.2315 36.0018 64.8549 32.5787 60.7337 30.3463C57.9979 28.8628 55.0011 27.9412 51.9144 27.6342C48.8276 27.3272 45.7114 27.6408 42.744 28.5571C39.7767 29.4733 37.0162 30.9742 34.6204 32.9741C32.2246 34.974 30.2404 37.4336 28.7812 40.2123Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1935 42.0768C30.3784 45.5701 29.6129 49.5375 29.9938 53.4774C30.3747 57.4172 31.8848 61.1527 34.3333 64.2114C36.7819 67.2702 40.059 69.5149 43.7501 70.662C47.4412 71.8086 51.3806 71.806 55.0702 70.6545C58.76 69.5026 62.0343 67.2538 64.4791 64.1919C66.9239 61.1299 68.4294 57.3925 68.8055 53.4521C69.1815 49.5118 68.4112 45.5454 66.5918 42.0545C64.7723 38.5636 61.9853 35.7049 58.5835 33.84C56.324 32.6013 53.849 31.8318 51.2998 31.5754C48.7505 31.319 46.1772 31.5807 43.7265 32.3455C41.2759 33.1104 38.9959 34.3636 37.0171 36.0333C35.0382 37.703 33.3991 39.7566 32.1935 42.0768Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1081 50.3613C46.8655 50.7832 46.7629 51.2627 46.8133 51.7388C46.8637 52.215 47.0649 52.6665 47.3914 53.0363C47.7179 53.4062 48.1549 53.6776 48.6473 53.8162C49.1397 53.9549 49.6652 53.9547 50.1573 53.8155C50.6495 53.6763 51.0861 53.4043 51.4121 53.0341C51.7381 52.664 51.9387 52.2122 51.9886 51.736C52.0384 51.2598 51.9352 50.7805 51.6921 50.3588C51.449 49.9371 51.0769 49.5919 50.6229 49.3671C50.3221 49.2167 49.9924 49.1232 49.6526 49.0918C49.3129 49.0605 48.9697 49.092 48.6431 49.1844C48.3165 49.2768 48.0127 49.4283 47.7492 49.6302C47.4858 49.8322 47.268 50.0807 47.1081 50.3613Z",
    fill: "#9057F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3883 46H74.4883V60.168H78.3883V46Z",
    fill: "#1CC67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4531 52.5999L38.646 43.8887C38.3303 43.6011 38.146 43.2042 38.1335 42.7854C38.1209 42.3666 38.2814 41.9601 38.5792 41.6554C38.8771 41.3507 39.2882 41.1727 39.722 41.1606C40.1558 41.1485 40.5767 41.3032 40.8923 41.5908L50.6995 50.3021L48.4531 52.5999Z",
    fill: "#9057F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.124 53.0401L48.1016 51.3059L60.5032 36.8009C60.6147 36.6653 60.7513 36.5536 60.9051 36.472C61.059 36.3903 61.2272 36.3404 61.4 36.3251C61.5728 36.3098 61.7468 36.3293 61.9122 36.3826C62.0776 36.436 62.231 36.5221 62.3637 36.636C62.4965 36.7499 62.6061 36.8893 62.6861 37.0464C62.7661 37.2035 62.815 37.375 62.83 37.5514C62.8449 37.7277 62.8256 37.9053 62.7734 38.0741C62.7211 38.2429 62.6369 38.3996 62.5254 38.5352L50.124 53.0401Z",
    fill: "#9057F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8436_16811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8436_16811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 55,
    fill: "white",
    transform: "translate(26 24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.47e1f2d062de12eb6bd00c5cb3124204.svg";
export { ForwardRef as ReactComponent };